import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content-grid content-grid--subpage" }

import {onMounted, ref} from "vue"
import {useI18n} from "vue3-i18n"
import {useMemberService, useOrganizationService} from "@/inversify.config"
import {Member} from "@/types/entities/member"
import Breadcrumbs from "@/components/layout/Breadcrumbs.vue"
import BackLinkTitle from "@/components/layout/BackLinkTitle.vue"
import Card from "@/components/layout/Card.vue"
import MemberForm from "@/components/forms/MemberForm.vue"
import {notifyError, notifySuccess} from "@/notify";
import {useRouter} from "vue-router";
import {useMemberStore} from "@/stores/memberStore";
import {OrganizationType, Role} from "@/types";
import {IFullOrganization} from "@/types/entities/organization";
import Loader from "@/components/layout/Loader.vue";
import AdminResetMemberPassword from "@/views/admin/AdminResetMemberPassword.vue";

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'EditMemberForm',
  props: {
    organizationId: {},
    memberId: {}
  },
  async setup(__props: any) {

let __temp: any, __restore: any

const props = __props

const {t, getLocale} = useI18n()
const router = useRouter()
const memberStore = useMemberStore()
const memberService = useMemberService()
const organizationService = useOrganizationService()

const organizationId = props.organizationId ? props.organizationId : memberStore.getMember.organizationId
const existingMember = ref<Member>((
  ([__temp,__restore] = _withAsyncContext(() => memberService.getMember(organizationId, props.memberId))),
  __temp = await __temp,
  __restore(),
  __temp
))
const hasIndividualAndCoOwnerRoles = ref<boolean>(existingMember.value.roles != undefined &&
  existingMember.value.roles.includes(Role.RegularIndividual) &&
  existingMember.value.roles.includes(Role.RegularSyndicateCoOwner))

let organization = ref<IFullOrganization>()
let isSyndicate = ref<boolean>(false)

onMounted(async () => {
  organization.value = memberStore.hasRole(Role.Admin)
      ? await organizationService.getOrganizationWithId(organizationId)
      : await organizationService.getMyOrganization(getLocale())
  isSyndicate.value = organization.value?.type === OrganizationType.RegularSyndicate
})

async function handleSubmit(member: Member) {
  if (isSyndicate.value && hasIndividualAndCoOwnerRoles.value && member.jobTitle == t('member.jobTitle.administrator.value')) {
    notifyError(t('validation.member.edit.individualMemberCannotHaveSyndicateAdminRole'))
    return;
  }

  let succeededOrNotResponse = await memberService.updateMember(member, organizationId)
  if (succeededOrNotResponse && succeededOrNotResponse.succeeded) {
    notifySuccess(t('validation.member.edit.success'))
    setTimeout(() => {
      router.back();
    }, 1500);
  } else {
    let errorMessages = succeededOrNotResponse.getErrorMessages('validation.member.edit');
    if (errorMessages.length == 0)
      notifyError(t('validation.member.edit.errorOccurred'))
    else
      notifyError(errorMessages[0])
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Breadcrumbs, {
      title: _unref(t)(`routes.admin.children.organizations.editMember.name`)
    }, null, 8, ["title"]),
    _createVNode(BackLinkTitle, {
      title: _unref(t)(`routes.admin.children.organizations.editMember.name`)
    }, null, 8, ["title"]),
    _createVNode(Card, null, {
      default: _withCtx(() => [
        (_unref(organization))
          ? (_openBlock(), _createBlock(MemberForm, {
              key: 0,
              "is-syndicate-organization": _unref(isSyndicate),
              member: existingMember.value,
              onFormSubmit: handleSubmit
            }, null, 8, ["is-syndicate-organization", "member"]))
          : (_openBlock(), _createBlock(Loader, {
              key: 1,
              "is-inline": true
            }))
      ]),
      _: 1
    }),
    (_unref(memberStore).hasRole(_unref(Role).Admin))
      ? (_openBlock(), _createBlock(AdminResetMemberPassword, {
          key: 0,
          "organization-id": props.organizationId,
          "member-id": props.memberId
        }, null, 8, ["organization-id", "member-id"]))
      : _createCommentVNode("", true)
  ]))
}
}

})